import styled from "styled-components";

export const Heading = styled.div`
  font: normal normal 600 16px/22px Open Sans;
  color: ${({ theme, selected }) => {
    if (selected) {
      return theme.colors.green;
    } else {
      return theme.colors.darkgrey;
    }
  }};
`;

export const Label = styled.div`
  font: normal normal normal 14px/19px Open Sans;
  color: #707070;
  text-transform: capitalize;
`;
